var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as _ from "lodash";
import { styled } from '../../theme/ThemeHelpers';
import MasonryItem from './components/MasonryItem';
var elementResizeDetectorMaker = require("element-resize-detector");
var erdUltraFast = elementResizeDetectorMaker({
    strategy: "scroll" //<- For ultra performance.
});
var nCols = function (cols, width) {
    return _.join(_.times(cols, function (i) { return "".concat(width, "px"); }), " ");
};
var ieCols = function (cols, width, gap) {
    return _.join(_.times(cols, function (i) { return i < cols - 1 ? "".concat(width, "px ").concat(gap, "px") : "".concat(width, "px"); }), " ");
};
var ieRows = function (rows, rowHeight, gap) {
    if (!rows)
        return "".concat(rowHeight !== null && rowHeight !== void 0 ? rowHeight : 100, "px ").concat(gap, "px");
    return _.join(_.times(rows, function (i) { return i < rows - 1 ? "".concat(rowHeight, "px ").concat(gap, "px") : "".concat(rowHeight, "px"); }), " ");
};
var Container = styled.div(function (props) {
    var _a;
    return "\n    display: grid;\n    display: -ms-grid;\n    -ms-grid-columns: ".concat(ieCols(props.cols, props.colWidth, props.gap), ";\n    -ms-grid-rows: ").concat(ieRows(props.rows, props.rowHeight, props.gap), ";\n    grid-gap: ").concat(props.gap, "px;\n    grid-template-columns: ").concat(nCols(props.cols, props.colWidth), ";\n    grid-auto-rows: ").concat((_a = props.rowHeight + "px") !== null && _a !== void 0 ? _a : "auto", ";\n");
});
var MasonryGrid = /** @class */ (function (_super) {
    __extends(MasonryGrid, _super);
    function MasonryGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.rowCalc = {};
        _this.done = 0;
        _this.startRows = [];
        _this.startCols = [];
        _this.calcCols = function () {
            var _a, _b;
            var cols = 4;
            if (_this.state.width) {
                //            console.log("width => ", this.state.width);
                var cs = (_a = _this.props.columnStrategy) !== null && _a !== void 0 ? _a : "maxColumnWidth";
                var g = (_b = _this.props.gap) !== null && _b !== void 0 ? _b : 10;
                var minS = _this.state.width / _this.props.maxWidth;
                var maxS = _this.state.width / _this.props.minWidth;
                //            console.log("minS = ", minS, ", maxS = ", maxS);
                switch (cs) {
                    case "maxColumnWidth":
                        cols = Math.min(Math.ceil(minS), Math.floor(maxS));
                        break;
                    case "maxColumns":
                        cols = Math.max(Math.ceil(minS), Math.floor(maxS));
                        break;
                    case "average":
                        cols = Math.ceil((minS + maxS) / 2);
                        break;
                }
            }
            return cols;
        };
        _this.setRef = function (ref) {
            if (ref) {
                erdUltraFast.listenTo({}, ref, function (ele) {
                    var w = ele.offsetWidth;
                    if (w > 0 && _this.state.width !== w)
                        _this.setState({ width: w });
                });
            }
        };
        _this.spanCalculated = function (index, span) {
            var cols = _this.calcCols();
            var col = 0;
            var row = _this.rowCalc[0];
            for (var c = 1; c < cols; c++) {
                if (_this.rowCalc[c] < row) {
                    row = _this.rowCalc[c];
                    col = c;
                }
            }
            _this.startRows[index] = _this.rowCalc[col];
            _this.startCols[index] = col + 1;
            _this.rowCalc[col] += span;
            _this.done++;
            if (_this.done === React.Children.count(_this.props.children)) {
                //            console.log(this.rowCalc);
                //            console.log(this.startRows);
                var maxRows_1 = 1;
                _.forEach(_this.startRows, function (v) {
                    if (v > maxRows_1)
                        maxRows_1 = v;
                });
                _this.setState({ startRows: _this.startRows, startCols: _this.startCols, maxRows: maxRows_1 });
            }
        };
        return _this;
    }
    MasonryGrid.prototype.render = function () {
        var _this = this;
        var _a;
        //        console.log(this.rowCalc);
        var childCo = React.Children.count(this.props.children);
        var cols = this.calcCols();
        var gap = (_a = this.props.gap) !== null && _a !== void 0 ? _a : 10;
        var colWidth = this.props.minWidth;
        if (this.state.width) {
            colWidth = (this.state.width - (cols - 1) * gap) / cols;
            if (colWidth >= this.props.maxWidth) {
                colWidth = this.props.maxWidth;
                gap = (this.state.width - (cols * colWidth)) / (cols - 1);
            }
        }
        this.rowCalc = {};
        for (var c = 0; c < cols; c++)
            this.rowCalc[c] = 1;
        this.done = 0;
        this.startRows = _.times(childCo, function (i) { return 1; });
        this.startCols = _.times(childCo, function (i) { return 1; });
        //        console.log("cols => ", cols, ", gap = ", gap, ", width = ", colWidth);
        return (React.createElement("div", { style: { margin: "auto" }, ref: this.setRef },
            React.createElement(Container, { rowHeight: this.props.rowHeight, colWidth: colWidth, gap: gap, cols: cols, rows: this.state.maxRows }, this.state.width && React.Children.map(this.props.children, function (child, i) {
                var _a;
                return (React.createElement(MasonryItem, { key: i, i: i, rowHeight: (_a = _this.props.rowHeight) !== null && _a !== void 0 ? _a : 100, col: _this.state.startCols ? _this.state.startCols[i] : 1, spanCalculated: _this.spanCalculated, row: _this.state.startRows ? _this.state.startRows[i] : undefined, backgroundColor: _this.props.itemBackgroundColor }, child));
            }))));
    };
    return MasonryGrid;
}(React.Component));
export default MasonryGrid;
//# sourceMappingURL=MasonryGrid.js.map